(() => {
  const ROOT_SELECTOR = '[data-abio-b2b]';
  const timers = new WeakMap();

  function getChecked(root, selector) {
    const element = root.querySelector(`${selector}:checked`);
    return element ? element.value : '';
  }

  function sync(root) {
    const type = getChecked(root, '[data-abio-type]');
    const isProfessional = type === 'Professionnel';

    const professional = root.querySelector('[data-abio-professional]');
    const company = root.querySelector('[data-abio-company]');

    const franceYes = root.querySelector('[data-abio-france="yes"]');
    const franceNo = root.querySelector('[data-abio-france="no"]');

    const siretWrapper = root.querySelector('[data-abio-siret-wrapper]');
    const siret = root.querySelector('[data-abio-siret]');
    const siren = root.querySelector('[data-abio-siren]');

    const vatYes = root.querySelector('[data-abio-vat-status="yes"]');
    const vatNo = root.querySelector('[data-abio-vat-status="no"]');

    const vatWrapper = root.querySelector('[data-abio-vat-wrapper]');
    const vat = root.querySelector('[data-abio-vat]');

    professional.hidden = !isProfessional;

    company.required = isProfessional;
    franceYes.required = isProfessional;
    franceNo.required = isProfessional;
    vatYes.required = isProfessional;
    vatNo.required = isProfessional;

    if (!isProfessional) {
      company.value = '';

      franceYes.checked = false;
      franceNo.checked = false;

      siret.value = '';
      siren.value = '';

      vatYes.checked = false;
      vatNo.checked = false;
      vat.value = '';

      siret.required = false;
      vat.required = false;

      siret.setCustomValidity('');

      siretWrapper.hidden = true;
      vatWrapper.hidden = true;

      return;
    }

    const isFrance = franceYes.checked;

    siretWrapper.hidden = !isFrance;
    siret.required = isFrance;

    if (!isFrance) {
      siret.value = '';
      siren.value = '';
      siret.setCustomValidity('');
    } else {
      const raw = siret.value.trim();
      const digits = raw.replace(/\D/g, '');
      const validCharacters = /^[0-9 ]*$/.test(raw);

      siren.value = digits.length >= 9
        ? digits.substring(0, 9)
        : '';

      if (raw !== '' && (!validCharacters || digits.length !== 14)) {
        siret.setCustomValidity(
          'Veuillez saisir un numéro de SIRET valide composé de 14 chiffres.'
        );
      } else {
        siret.setCustomValidity('');
      }
    }

    const hasVat = vatYes.checked;

    vatWrapper.hidden = !hasVat;
    vat.required = hasVat;

    if (!hasVat) {
      vat.value = '';
    }
  }

  function saveAttributes(root) {
    const type = getChecked(root, '[data-abio-type]');

    const attributes = {
      'Type de client': type,
      'Raison sociale':
        root.querySelector('[data-abio-company]')?.value.trim() || '',
      'Entreprise en France':
        getChecked(root, '[data-abio-france]'),
      'SIRET':
        root.querySelector('[data-abio-siret]')?.value.trim() || '',
      'SIREN':
        root.querySelector('[data-abio-siren]')?.value.trim() || '',
      'Numéro de TVA disponible':
        getChecked(root, '[data-abio-vat-status]'),
      'Numéro de TVA intracommunautaire':
        root.querySelector('[data-abio-vat]')?.value.trim().toUpperCase() || ''
    };

    const baseUrl =
      window.routes?.cart_update_url || '/cart/update';

    const url = baseUrl.replace(/\.js$/, '') + '.js';

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes })
    }).catch(() => {
      // La soumission normale du panier conservera aussi les champs.
    });
  }

  function scheduleSave(root) {
    clearTimeout(timers.get(root));

    const timer = setTimeout(() => {
      saveAttributes(root);
    }, 500);

    timers.set(root, timer);
  }

  function initialize() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(sync);
  }

  document.addEventListener('change', (event) => {
    const root = event.target.closest(ROOT_SELECTOR);

    if (!root) return;

    sync(root);
    saveAttributes(root);
  });

  document.addEventListener('input', (event) => {
    const root = event.target.closest(ROOT_SELECTOR);

    if (!root) return;

    sync(root);
    scheduleSave(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  new MutationObserver(() => {
    initialize();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
})();